













































import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
	components: {}
})
export default class MainExplanation extends Vue {
	get selectedView() {
		return this.$tStore.state.selectedView
	}

	@Watch('selectedView')
	viewChanged() {
		// Once someone changes away from the initial view, display view-specific help
		this.$el.getElementsByClassName('content')[0].scrollTop = 0
	}
}
